import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBooking = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 20 19.56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22 5.75543C22 3.68275 20.3165 2 18.2438 2H5.75617C3.68351 2 2 3.68275 2 5.75543V17.8044C2 19.8765 3.68351 21.5598 5.75618 21.5598H18.2438C20.3165 21.5598 22 19.8765 22 17.8044L22 5.75543Z",
			fill: "#0C3B7C"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 14.1516H11.9888V21.5598H2.00001L2 14.1516Z",
			fill: "#0C3B7C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0903 14.9469L9.47942 14.9453V13.0191C9.47942 12.6076 9.63906 12.3934 9.99124 12.3445H11.0903C11.8741 12.3445 12.3811 12.8386 12.3811 13.6385C12.3811 14.4599 11.8869 14.9461 11.0903 14.9469ZM9.47942 9.7517V9.2447C9.47942 8.80107 9.66714 8.59008 10.0787 8.56281H10.9034C11.6101 8.56281 12.0337 8.98558 12.0337 9.69394C12.0337 10.233 11.7433 10.8628 10.929 10.8628H9.47942V9.7517ZM13.1472 11.6738L12.856 11.5102L13.1103 11.2928C13.4063 11.0385 13.9021 10.4665 13.9021 9.47974C13.9021 7.96836 12.73 6.99366 10.9162 6.99366H8.84647V6.99286H8.61061C8.07313 7.01292 7.64233 7.45013 7.63672 7.99083V16.5666H10.9571C12.9731 16.5666 14.2743 15.4691 14.2743 13.7692C14.2743 12.8539 13.8539 12.0717 13.1472 11.6738Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1387 15.3819C15.1387 14.7268 15.667 14.1968 16.318 14.1968C16.9707 14.1968 17.5015 14.7268 17.5015 15.3819C17.5015 16.0362 16.9707 16.567 16.318 16.567C15.667 16.567 15.1387 16.0362 15.1387 15.3819Z",
			fill: "#00BAFC"
		})
	]
});
const ForwardRef = forwardRef(SvgBooking);
export { ForwardRef as ReactComponent };
